import '../styles/components/ProductDisplayCard.scss'
import { useNavigate } from 'react-router-dom';

const ProductDisplayCard = ({ image, product }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (product && product.name) {
            navigate(`/Products/${product.name}`, { state: { id: product.id } });
        }
    };

    return(
        <div className="product-display-card" onClick={handleClick} style={{ cursor: product ? 'pointer' : 'default' }}>
            <img src={image} alt={product?.name || 'product image'} />
        </div>
    )
}

export default ProductDisplayCard;